export enum CLICK_ACTION_POSTBACK {
    ClearScreen = "RESPONSE_ID=CLEAR_SCREEN"
}